import createApiService from "../../http";
import getStory from '../../story';
export const FETCH_BLOGS = '/news';
export const FETCH_FILTERED_BLOG = '/blog/filters?type=';
export const FETCH_SINGLE_BLOG = '/news';
export const FETCH_FEATURED_BLOG = '/news/featured';
export const FETCH_POPULAR_BLOG = '/news/popular';
export const ADD_BLOG = '/news';

export const fetchBlogService = (params) => {
  let sentParams = {};
  if(params.type && !params?.country) {
    sentParams = {
      filter_query: {
        type: {
          like: params.type
        }
      },
    }
  }

  if(params.country && !params?.type) {
    sentParams = {
      filter_query: {
        country: {
          in_array: params.country
        }
      },
    }
  }

  if(params.country && params?.type) {
    sentParams = {
      filter_query: {
        country: {
          in_array: params.country
        },
        type: {
          like: params.type
        }
      },
    }
  }

  if(params.exclude) {
    sentParams = {
      filter_query: {
      ...sentParams?.filter_query,
      title: {
        not_in: params.exclude
      }
      },
    }
  }
  
  return getStory('', {
  ...sentParams,
  page: params?.page,
  per_page: params?.count,
  starts_with: 'blogs',
})};

export const fetchPopularBlogService = (params) => createApiService({
    endpoint: FETCH_POPULAR_BLOG,
    method: 'get',
    options: {
        params: {
          ...params,
        },
      },
});


export const fetchSingleBlogsService = (id) => getStory(id);

export const fetchFeaturedBlogsService = (params) => createApiService({
    endpoint: FETCH_FEATURED_BLOG,
    method: 'get',
    options: {
      params: {
        ...params,
      },
    },
});

export const fetchBlogsByFilterService = (type) => createApiService({
    endpoint: `${FETCH_FILTERED_BLOG}${type}`,
    method: 'get'
});

export const createBlogService = (token) =>
  createApiService({
    endpoint: ADD_BLOG,
    method: "post",
    options: {
      headers: {
        // "content-type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    },
  });

  export const fetchBlogServiceAdmin = (params) => createApiService({
    endpoint: FETCH_BLOGS,
    method: 'get',
    options: {
        params: {
          ...params,
        },
      },
});